import script from "./FileDragElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileDragElement.vue?vue&type=script&setup=true&lang=ts"

import "./FileDragElement.vue?vue&type=style&index=0&id=e72c8ddc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e72c8ddc"]])

export default __exports__